/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {ColumnManager} from './column-manager';
import {ColumnGroup} from './column-group';

export class ColumnGroupManager {

  public columnGroups: ColumnGroup[];

  constructor() {
    this.columnGroups = [];
  }

  public add(column: ColumnManager) {
    if (column.property.tableGroup) {
      const group =
        this.columnGroups.find((gr) => gr.title.localeCompare(column.property.tableGroup) === 0);
      if (group) {
        group.columns.push(column);
      } else {
        const newGroup = new ColumnGroup(column.property.tableGroup, [column]);
        this.columnGroups.push(newGroup);
      }
    } else {
      const gr = this.findGroup(column.property.id);
      if (!gr) {
        this.columnGroups.push(new ColumnGroup(column.property.id, [column], true));
      } else {
        gr.columns = [column];
      }
    }
  }

  public refreshWidth() {
    for (const group of this.columnGroups) {
      group.refreshWidth();
    }
  }

  public reset() {
    this.columnGroups = [];
  }

  public indexOf(title: string) {
    return this.columnGroups.findIndex((gr) => gr.title.localeCompare(title) === 0);
  }

  public move(title: string, position: number) {
    const oldIndex = this.indexOf(title);
    const group = this.columnGroups.splice(oldIndex, 1);
    if (group.length > 0) {
      this.columnGroups.splice(position, 0, group[0]);
    }
  }

  generateDisplayColumns(): ColumnManager[] {
    const array: ColumnManager[] = [];
    for (const group of this.columnGroups) {
      for (const c of group.columns) {
        array.push(c);
      }
    }
    return array;
  }

  findGroup(groupLabel: string): ColumnGroup {
    return this.columnGroups.find((cg) => cg.title === groupLabel);
  }

  generate(columns: ColumnManager[]) {
    for (const gr of this.columnGroups) {
      gr.columns = [];
    }
    columns.forEach((c) => this.add(c));
    this.refreshWidth();
  }

  /**
   * Return the list of group and regroup all "no-group" column on one group
   */
  public getGroups(): ColumnGroup[] {
    const array: ColumnGroup[] = [];
    const noGroupColumns = new ColumnGroup('dataTable.noGroupColumn', [], true);
    for (const gr of this.columnGroups) {
      if (gr.noGroup) {
        for (const c of gr.columns) {
          noGroupColumns.columns.push(c);
        }
      } else {
        array.push(gr);
      }
    }
    if (noGroupColumns.columns.length) {
      array.push(noGroupColumns);
    }
    return array;
  }

  public findGroups(titles: string[]): ColumnGroup[] {
    const array: ColumnGroup[] = [];
    for (const title of titles) {
      const gr = this.columnGroups.find((t) => t.title === title);
      if (gr) {
        array.push(gr);
      }
    }
    return array;
  }

  public refreshFixedColumn(multiSelection: boolean, index: boolean) {
    let offset = 0;
    if (multiSelection) {
      offset += 25;
    }
    if (index) {
      offset += 30;
    }
    for (const group of this.columnGroups) {
      offset += group.refreshFixedWidth(offset);
    }
  }
}
